const ZHHANS_CUSTOM = {
  accessToWifi: '充电地点可提供 Wi-Fi 连接',
  AFTER_10PM_BEFORE_11AM: '晚上10点以后；上午11点以前',
  AFTER_11AM_BEFORE_10PM: '上午11点之后；晚上10点之前',
  AFTER_1230AM_BEFORE_930AM: '凌晨12:30之后；上午9:30之前',
  AFTER_12PM_BEFORE_8PM: '中午12点后；晚上8点前',
  AFTER_2PM_BEFORE_6PM: '下午2点后；下午6点前',
  AFTER_6AM_BEFORE_3PM: '早上6点以后；下午3点以前',
  AFTER_6PM_BEFORE_9AM: '下午6点后；上午9点前',
  AFTER_8AM_BEFORE_MN: '上午8点之后；午夜之前',
  AFTER_9PM_BEFORE_6AM: '晚上9点以后；早上6点以前',
  AFTER_9PM_BEFORE_9AM: '晚上9点后；上午9点前',
  AFTER_MN_BEFORE_8AM: '午夜之后；上午8点之前',
  'after.Incentives': '奖励后',
  age: '年龄',
  agreeOffPeakSchedule: '同意按非高峰时段收费',
  all: '全部',
  ALL_HOURS: '所有时间（不可预测）',
  'assumption.downPayment': '首付',
  'assumption.downPaymentValue': '建议零售价的 10% + 税',
  'assumption.electricityRate': '电费',
  'assumption.gasolinePrice': '汽油价格',
  'assumption.salesTax': '销售税',
  'assumption.salesTaxPercent': '销售税%',
  ATTACHED_GARAGE: '附属车库',
  averageMonthlyCharge: '平均每月费用',
  averageMonthlyCharge_tool:
    '请选择您每月典型电费账单（不含燃气费）的总额，此金额不受季节影响。我们将以此金额估算您当前的能源消耗基准。',
  basement: '地下室',
  basicFilters: '基本筛选器',
  certifiedElectrician: '持证电工',
  charger: '充电器',
  chargeWithLevelTwoCharger:
    '使用符合条件的二级充电器充电，或驾驶符合条件的电动汽车。',
  charging: '收费',
  'chargingMap.businessGovernment': '由企业或政府安装',
  'chargingMap.DCChargers': '直流快充或超级充电器',
  'chargingMap.disclaimer':
    '数据由替代燃料数据中心提供。地图可能无法反映充电站的最新可用情况。',
  'chargingMap.errorZipcode': '错误：{workingZipcode} 不是有效的邮政编码',
  'chargingMap.highPowerStations': '高功率电站',
  'chargingMap.otherSttations': '其他类型的车站',
  'chargingMap.privateStations': '私人车站',
  'chargingMap.public': '公共车站',
  'chargingMap.searchDealers': '搜索合格经销商',
  'chargingMap.showFullListOfStations': '完整电台列表',
  'chargingMap.updateZipcode': '更新邮政编码',
  chargingStations: '充电站',
  'chargingStations.mapLegend.high': '高功率电站',
  'chargingStations.mapLegend.highSubtext': '直流快充或超级充电器',
  'chargingStations.mapLegend.other': '其他类型的车站',
  'chargingStations.mapLegend.private': '私人车站',
  'chargingStations.mapLegend.public': '公共车站',
  'chargingStations.mapLegend.publicSubtext': '由企业或政府安装',
  'chargingWizard.carOvernight': '你打算把车停在哪里过夜？',
  'chargingWizard.chargingAvailability': '充电可用性',
  'chargingWizard.electricianInstall': '电工可以安装充电站吗？',
  'chargingWizard.noChargingAvailability': '无充电功能',
  'chargingWizard.onTheStreet': '在街上',
  'chargingWizard.overnightParking': '您能否将车停放在设有充电桩的停车位过夜？',
  'chargingWizard.parkingGarage': '私人车库或停车位',
  'chargingWizard.powerOutlet': '你停车的地方附近有普通的电源插座吗？',
  'chargingWizard.publicParking': '公共停车场',
  'chargingWizard.useThisValue': '使用此值',
  'chargingWizard.youWouldHave': '您将拥有{resultText}',
  close: '关闭',
  compareVehicles: '车辆对比',
  'compareVehicles.carMake': '汽车品牌',
  'compareVehicles.carModel': '汽车模型',
  'compareVehicles.disclaimer': '并非所有品牌/型号都有现货。',
  'compareVehicles.fuelType': '燃料类型',
  'compareVehicles.pickTwo': '至少选择两辆车开始比较。',
  'compareVehicles.selectFuel': '选择燃料类型',
  'compareVehicles.selectMake': '选择品牌',
  'compareVehicles.selectModel': '选择型号',
  'compareVehicles.subTitle': '查看所有车辆 >',
  contact: '接触',
  ContactInformation: '联系信息',
  conventionalVehicleEfficiency: '传统车辆效率（mpg）',
  conventionalVehicleEfficiencyTooltip:
    '要计算可能的节省，请输入您要用纯电动或插电式混合动力电动汽车替换的汽油车的每加仑行驶里程 (MPG)。',
  costOfPublicCharging: '公共充电成本',
  costOfPublicChargingTooltip:
    '我们估算了付费公共充电站的费用，但如果您知道当地的充电费用，可以编辑此筛选条件。',
  CountiesCovered: '覆盖的县',
  currency: '$',
  currentPricingPlan: '当前定价方案',
  dealers: '经销商',
  'dealers.allBrands': '所有品牌',
  'dealers.allDealers': '所有经销商',
  'dealers.brands': '品牌',
  'dealers.contact': '接触',
  'dealers.findDealers': '查找经销商',
  'dealers.website': '网站',
  description: '描述',
  DETACHED_GARAGE: '独立车库',
  detailedCalculations: '细节',
  driveEVOrPHEV: '驾驶电动汽车（纯电动汽车或插电式混合动力汽车）',
  DRIVEWAY: '不在车库里',
  DRParagraph1:
    '标准的需求响应定价方案基于您的用电量，\n\n而不是用电时间。用电量越少，费用越低\n\n——无论白天还是晚上。',
  DRParagraph2:
    '该方案可能非常适合用电量较低的家庭以及那些\n\n更喜欢节约能源而不考虑时间因素的家庭。',
  egbBringCharger: '我将使用我自己的二级充电器。',
  egbNeedCharger: '我需要一个二级充电器',
  egbOurPrograms:
    '我们提供多种方案，让您在家充电更轻松。如果您需要二级充电器，我们的“电动汽车家庭加速充电”方案或许正适合您。',
  electricians: '电工',
  'electricians.commercial': '商业的',
  'electricians.fastEfficient':
    '{title} 我们的安装时间表有保障，并且会加快速度，以帮助您更快地投入使用。',
  'electricians.industrial': '工业的',
  'electricians.map.caption':
    '您是圣地亚哥地区经认证的电动汽车充电站安装商吗？请联系{email}，以便我们考虑将您纳入认证电工数据库。本网站所列电工均未获得圣地亚哥天然气与电力公司 (SDG&E) 的认可、赞助或雇佣。',
  'electricians.map.header': '我们优选合作伙伴的优势',
  'electricians.map.personalizedExperience':
    '{title} 我们的电动汽车专家可以指导您完成整个流程。',
  'electricians.map.value': '我们提供极具竞争力的安装价格。',
  'electricians.residential': '住宅',
  'electricians.searchElectricians': '寻找合格的电工',
  'electricians.subtitle':
    '输入您的邮政编码，查找您所在地区的持证电工。点击搜索结果即可查看位置和联系方式。',
  'electricians.title': '持证电工',
  'electricians.type': '电工类型',
  'electricians.worldClass':
    '我们与经过严格筛选的经验丰富的电工合作，以确保安全专业的安装。',
  electricity: '电',
  electricPortion: '电动部分',
  electricVehicles: '电动汽车',
  emissions: '排放量',
  'Energy Information Administration': '美国能源信息署',
  estimatedDIYCost: '预计平均DIY成本：',
  'ev.avg.range': '平均电续航里程',
  'ev.carDetails.batterySizeTooltip':
    '一千瓦时（kWh）的能量足以行驶1到4英里，具体取决于车辆。而普通笔记本电脑的电池容量不到0.1千瓦时。',
  'ev.cardetails.calc.arborDayFoundation': '植树节基金会',
  'ev.carDetails.calc.charging': '收费',
  'ev.cardetails.calc.chargingRate': '充电速率',
  'ev.carDetails.calc.chargingRate': '充电速率',
  'ev.carDetails.calc.DCFC': '直流快速充电（DCFC）速率',
  'ev.cardetails.calc.dcRate': '直流快速充电（DCFC）速率',
  'ev.cardetails.calc.description': '描述',
  'ev.carDetails.calc.description': '描述',
  'ev.cardetails.calc.EIA': '美国能源信息署',
  'ev.cardetails.calc.electricEmissions': '电力排放量（磅）',
  'ev.cardetails.calc.electricEmissionsLbsMwh': '电力排放量（磅/兆瓦时）',
  'ev.cardetails.calc.electricEmissionsLbsMwhMetric':
    '电力排放量（千克/兆瓦时）',
  'ev.cardetails.calc.electricEmissionsMetric': '以千克计的电力排放量',
  'ev.cardetails.calc.electricityEmissions': '电力二氧化碳排放量（磅/兆瓦时）',
  'ev.cardetails.calc.electricityEmissionsMetric':
    '电力二氧化碳排放量（千克/兆瓦时）',
  'ev.carDetails.calc.electricityEmissionsMetric':
    '电力二氧化碳排放量（千克/兆瓦时）',
  'ev.carDetails.calc.emissions': '排放量',
  'ev.cardetails.calc.emissionsPerTree': '每棵树减少的排放量',
  'ev.cardetails.calc.emissionsReductions': '减排',
  'ev.cardetails.calc.emissionsReudctions': '减排',
  'ev.cardetails.calc.EPA': '美国环保署能效等级',
  'ev.cardetails.calc.EPAMetric': 'NRC效率评级',
  'ev.carDetails.calc.ev.cardetails.calc.electricityEmissions':
    '电力二氧化碳排放量（磅/兆瓦时）',
  'ev.carDetails.calc.fuel': '燃料',
  'ev.cardetails.calc.FuelConsumptionCa': '加拿大燃油消耗指南',
  'ev.cardetails.calc.gallonsSaved': '节省的加仑数',
  'ev.cardetails.calc.gallonsSavedFormula':
    '同等燃油车的油耗（加仑）- 电动汽车的油耗（加仑）',
  'ev.cardetails.calc.gallonsUsed': '加仑数',
  'ev.cardetails.calc.gallonsUsedFormula':
    '行驶里程 * (1 - 电动行驶部分) / 英里/加仑',
  'ev.cardetails.calc.gasolineEmissions': '汽油排放量（磅/加仑）',
  'ev.cardetails.calc.gasolineEmissionskg': '汽油排放量（千克）',
  'ev.cardetails.calc.gasolineEmissionsLbs': '汽油排放量（磅）',
  'ev.cardetails.calc.gasolineEmissionsMetric': '汽油排放量（千克/升）',
  'ev.cardetails.calc.gasolineEmissionsYr': '汽油二氧化碳排放量（磅/年）',
  'ev.cardetails.calc.gasolineEmissionsYrMetric':
    '汽油二氧化碳排放量（千克/年）',
  'ev.cardetails.calc.kgCo2PerYr': '每年二氧化碳排放量（公斤）',
  'ev.cardetails.calc.kmDrivenPerYr': '每年行驶公里数',
  'ev.carDetails.calc.kmDrivenPerYr': '每年行驶公里数',
  'ev.carDetails.calc.kwPerKm': '每百公里耗电量（千瓦时）',
  'ev.carDetails.calc.kwPerMile': '每百英里千瓦时',
  'ev.cardetails.calc.lbsCo2PerYr': '每年排放的二氧化碳磅数',
  'ev.cardetails.calc.litersSaved': '节省的升数',
  'ev.cardetails.calc.litersSavedFormula':
    '同等燃油车的油耗（升）- 电动汽车的油耗（升）',
  'ev.cardetails.calc.litersUsed': '升数',
  'ev.cardetails.calc.litersUsedFormula':
    '行驶公里数 * (1 - 电动行驶部分) * 升/百公里',
  'ev.cardetails.calc.lPer100Km': '升/百公里',
  'ev.cardetails.calc.lPerKm': '每百公里油耗（升）',
  'ev.cardetails.calc.lpkm': '升/公里',
  'ev.cardetails.calc.lvl2FullCharge': '2级完全充电所需时间',
  'ev.cardetails.calc.lvlTwoChargingRate': '二级充电速率',
  'ev.cardetails.calc.maxACIntake': '车辆最大空调进气量',
  'ev.carDetails.calc.milesDriven': '每年行驶里程',
  'ev.cardetails.calc.milesDrivenPerYr': '每年行驶里程',
  'ev.cardetails.calc.milesPerGallon': '每加仑行驶里程（MPG）',
  'ev.carDetails.calc.milesPerGallonBasic': '每加仑行驶里程',
  'ev.cardetails.calc.minOflvl2AC': '2级充电速率最低要求和车辆最大空调进气量',
  'ev.cardetails.calc.mpg': '英里/加仑',
  'ev.cardetails.calc.nationalAverageElectricityEmissions':
    '全国平均电力排放量',
  'ev.cardetails.calc.portionElectric': '电动驾驶部分',
  'ev.cardetails.calc.portionElectricSource':
    '用户输入。对于混合动力汽车，估算使用电池而非汽油行驶的里程比例。',
  'ev.cardetails.calc.source': '来源',
  'ev.carDetails.calc.source': '来源',
  'ev.cardetails.calc.userInput': '用户输入',
  'ev.cardetails.calc.vehicleBatteryCapacity': '车辆电池容量',
  'ev.carDetails.compareText':
    '我们根据品牌、尺寸和价格，选择与 {vehicle} 接近的 {gasVehicle}。',
  'ev.cardetails.electricRange':
    '考虑到电池性能衰减，此处所列续航里程是根据车辆使用年限和正常驾驶/充电模式估算得出的。',
  'ev.carDetails.fastChargingTooltip': '直流快速充电速度：',
  'ev.carDetails.gasolineSaved': '节省汽油',
  'ev.carDetails.kilometerBatterySizeTooltip':
    '一千瓦时（kWh）的能量足以行驶1到4英里，具体取决于车辆。而普通笔记本电脑的电池容量不到0.1千瓦时。',
  'ev.carDetails.kilometerUsedBatterySizeTooltip':
    '一千瓦时 (kWh) 的能量足以行驶 1 至 4 公里，具体取决于车辆。考虑到二手电动汽车的电池衰减，此处引用的电池容量是根据车辆的使用年限和正常的驾驶/充电模式估算得出的。',
  'ev.carDetails.levelTwoChargerSpeedTooltip':
    '使用能够支持该车辆最大车载充电功率的公共或私人二级充电桩进行充电时，请注意，消费者能源公司 (Consumers Energy) 的住宅用户补贴计划建议住宅充电装置的电路功率不超过 240V/40A (9.6 kW)。',
  'ev.carDetails.mobile':
    '有关图表 {amp} 计算的更多详细信息，请在电脑上查看此页面。',
  'ev.carDetails.treesPlanted': '种植的树木',
  'ev.carDetails.usedBatterySizeTooltip':
    '一千瓦时 (kWh) 的能量足以行驶 1 至 4 英里，具体取决于车辆。考虑到二手电动汽车的电池衰减，此处引用的电池容量是根据车辆的使用年限和正常的驾驶/充电模式估算的。',
  'ev.carDetails.view': '查看车辆详情',
  'ev.cash': '现金',
  'ev.chargingStations.body':
    '现在随时随地充电比以往任何时候都更加便捷。输入您的位置即可查看附近的所有充电站。',
  'ev.compareGasVehicle': '将{car}与类似的汽油车{gasCar}进行比较。',
  'ev.compareOtherVehicles': '与其他车辆进行比较',
  'ev.costOfPublicCharing': '公共充电的预计成本',
  'ev.dealers.body':
    '查找您所在地区的电动汽车经销商，点击每个经销商即可查看其位置和联系信息。',
  'ev.electricityRateCalc':
    '电价按平均家庭用电量 700 千瓦时 (kWh) 计算，采用综合费率。了解更多信息，请点击 {website}',
  'ev.electricPortion': '电动里程占比',
  'ev.electricPortionTooltip':
    '估算一下您行驶里程中纯电动行驶的百分比。如果您每天充电，并且每天行驶里程少于您所选电动汽车的纯电续航里程，那么这个百分比将接近 100%。如果您不确定纯电动行驶的百分比，请选择 50%。',
  'ev.incentives.title':
    '最高可获得{savings}的税收抵免和退税{lineBreak}，适用于{car}',
  'ev.incentives.title.simple': '可获得的奖励和返利',
  'ev.interestRate': '利率',
  'ev.jumbotron.findADealer': '查找经销商',
  'ev.jumbotron.viewAllCars': '查看所有车辆',
  'ev.kilometersDrivenAnnually': '每年行驶公里数',
  'ev.lease': '租',
  'ev.loan': '贷款',
  'ev.matchScore.adjustment': '调整',
  'ev.matchScore.budget': '预算',
  'ev.matchScore.charging': '收费',
  'ev.matchScore.maxScore': '最高分',
  'ev.matchScore.popover': '您的匹配评分是根据您选择的偏好计算得出的。',
  'ev.matchScore.range': '范围',
  'ev.matchScore.seats': '座位',
  'ev.matchScore.title': '比赛比分',
  'ev.matchScore.totalScore': '总分',
  'ev.matchScore.yourScore': '你的得分',
  'ev.milesDrivenAnnually': '每年行驶里程',
  'ev.planningRoute.body':
    '现在随时随地充电比以往任何时候都更加便捷。输入您的目的地，即可查看沿途所有充电站。',
  'ev.public': '民众',
  'ev.publicPrivateCharging': '公共/私人混合充电',
  'ev.purchaseMethod': '购买方式',
  'ev.purchaseMethodToolTip':
    '租赁车辆时，租赁期满后您必须归还车辆。而贷款购车则不同，还清贷款后，您可以保留车辆。',
  'ev.reviews': '来自网络各处的评论',
  'ev.showSources.assumption': '假设：',
  'ev.showSources.averageInsurancePerYear': '平均每年保险费',
  'ev.showSources.blendedMaintenanceCostPerKilometer': '每公里综合维护成本',
  'ev.showSources.blendedMaintenanceCostPerKilometerSource':
    '电动驾驶部分适用于汽油和电力的每公里维护费用',
  'ev.showSources.blendedMaintenanceCostPerMile': '每英里综合维护成本',
  'ev.showSources.blendedMaintenanceCostPerMileSource':
    '电动驾驶部分应用于汽油和电力每英里的维护成本',
  'ev.showSources.capitalizedCost': '资本化成本',
  'ev.showSources.capitalizedCostSource': '厂商建议零售价 - 首付 - 资本化优惠',
  'ev.showSources.capitalizedIncentives': '资本化激励',
  'ev.showSources.capitalizedIncentivesSource': '租赁合同中资本化的激励措施',
  'ev.showSources.cashFormula':
    '车辆厂商建议零售价*（1 + 销售税）- 优惠 - 转售价值',
  'ev.showSources.dollarPerKilometerDriven': '每行驶100公里费用',
  'ev.showSources.dollarPerKilometerDrivenPublicCharging':
    '（公共充电预计成本 * 公共/私人混合充电 + 电价 * (1 - 公共/私人混合充电)）* 车辆每百公里耗电量（千瓦时）',
  'ev.showSources.dollarPerKilometerDrivenSource':
    '电力成本 * 车辆每百公里耗电量（千瓦时）',
  'ev.showSources.dollarPerMileDriven': '每行驶100英里费用',
  'ev.showSources.dollarPerMileDrivenPublicCharging':
    '（公共充电预计成本 * 公共/私人混合充电 + 电价 * (1 - 公共/私人混合充电)）* 车辆每百英里耗电量（千瓦时）',
  'ev.showSources.dollarPerMileDrivenSource':
    '电力成本 * 车辆每行驶 100 英里消耗的千瓦时数',
  'ev.showSources.electricityRate': '电价基于{website}',
  'ev.showSources.EPAEfficiency': '美国环保署能效等级',
  'ev.showSources.estimatedCostOfPublicCharging': '公共充电的预计成本',
  'ev.showSources.firstLeasePayment': '首期租赁付款',
  'ev.showSources.firstLeasePaymentSource': '首付 + 月租金',
  'ev.showSources.gasolineCost': '汽油成本',
  'ev.showSources.insurancePerYear': '每年保险费',
  'ev.showSources.insurancePerYearSource':
    '根据车辆厂商建议零售价 (MSRP) 与 {msrp} 平均厂商建议零售价 (MSRP) 的关系，推算 {state} 的平均保险成本',
  'ev.showSources.insuranceSource': '平均保险成本',
  'ev.showSources.kilometerVehicleKWh': '车辆每百公里耗电量（千瓦时）',
  'ev.showSources.leaseForumla':
    '首期租赁付款 + (所有权月数 - 1) * (月租赁付款) - 非资本化租赁优惠',
  'ev.showSources.lifetimeKilometers': '终身里程',
  'ev.showSources.lifetimeMiles': '终身里程',
  'ev.showSources.loanAmount': '贷款金额',
  'ev.showSources.loanFormula': '厂商建议零售价 * (1 + 销售税) - 首付',
  'ev.showSources.maintenanceCostReduction': '降低电动汽车维护成本',
  'ev.showSources.maintenanceCostReductionSource': '{website}',
  'ev.showSources.maintenancePerKilometer': '每公里汽油保养费用',
  'ev.showSources.maintenancePerKilometerElectricity': '每公里电力维护费用',
  'ev.showSources.maintenancePerKilometerElectricitySource':
    '汽油车每公里维护成本 * 电动汽车维护成本降低系数',
  'ev.showSources.maintenancePerMile': '每英里汽油维护费用',
  'ev.showSources.maintenancePerMileElectricity': '每英里电力维护费用',
  'ev.showSources.maintenancePerMileElectricitySource':
    '汽油车每英里维护成本 * 电动汽车维护成本降低系数',
  'ev.showSources.maintenancePerMileSource':
    '根据车辆厂商建议零售价（MSRP）与{averageMSRP}平均厂商建议零售价（MSRP）的关系，推断{avgMaintenanceCost}的平均维护成本。',
  'ev.showSources.mixPublicPrivateCharging': '公共/私人混合充电',
  'ev.showSources.moneyFactor': '资金因素',
  'ev.showSources.moneyFactorSource':
    '相当于用户输入{interestRateAsBasisPoints}',
  'ev.showSources.monthlyDepreciationCost': '每月折旧成本',
  'ev.showSources.monthlyDepreciationCostSource':
    '（资本化成本 - 残值）/ 持有月数',
  'ev.showSources.monthlyFinancingCost': '每月融资成本',
  'ev.showSources.monthlyFinancingCostSource':
    '（资本化成本 + 转售价值）* 资金系数',
  'ev.showSources.monthlyLeasePayment': '每月租金',
  'ev.showSources.monthlyLeasePaymentSource':
    '（每月折旧成本 + 每月融资成本）*（1 + 销售税）',
  'ev.showSources.monthlyPayments': '月供',
  'ev.showSources.monthlyPaymentsSource': '贷款金额、利率和持有期限的财务函数',
  'ev.showSources.monthsOfOwnership': '拥有时间（月）',
  'ev.showSources.nonCapLeaseIncentives': '非资本化租赁激励',
  'ev.showSources.nonCapLeaseIncentivesSource':
    '未计入资本化租赁成本的激励措施',
  'ev.showSources.portionElectricSource':
    '用户输入。对于混合动力汽车，估算使用电池而非汽油行驶的里程比例。',
  'ev.showSources.portionElectricSourceKilometer':
    '用户输入。对于混合动力汽车，估算使用电池而非汽油行驶的公里数比例。',
  'ev.showSources.resaleValue': '转售价值',
  'ev.showSources.resaleValueSource':
    '{carName}: e^(ln({resaleFactor})/36000*{lifetimeMiles})*MSRP',
  'ev.showSources.totalElectricityCost': '总电力成本',
  'ev.showSources.totalElectricityCostSource':
    '每行驶100英里费用 * 终身里程 * {portionEVDriving}/ 100',
  'ev.showSources.totalGasolineCost': '汽油总成本',
  'ev.showSources.totalGasolineCostSource':
    '汽油成本 * 终身里程 * {portionEVDriving}/ MPG',
  'ev.showSources.totalInsuranceCost': '总保险费用',
  'ev.showSources.totalInsuranceCostSource': '每年保险费用 * 车辆拥有年限',
  'ev.showSources.totalKilometerElectricityCostSource':
    '每百公里行驶费用 * 总行驶里程 * {portionEVDriving}/ 100',
  'ev.showSources.totalKilometerGasolineCostSource':
    '汽油成本 * 终身行驶里程 * {portionEVDriving}/升/公里',
  'ev.showSources.totalKilometerMaintenanceCostSource':
    '每公里维护成本 * 使用寿命里程',
  'ev.showSources.totalLoanFormula': '首付 + 月供总额 - 优惠 - 转售价值',
  'ev.showSources.totalMaintenanceCost': '总维护成本',
  'ev.showSources.totalMaintenanceCostSource': '每英里维护成本 * 终身里程',
  'ev.showSources.totalMonthlyPayments': '每月总付款额',
  'ev.showSources.totalMonthlyPaymentsSource': '月付款额 * 所有权期限',
  'ev.showSources.totalVehicleCost': '车辆总成本',
  'ev.showSources.vehicleKWh': '车辆每百英里耗电量（千瓦时）',
  'ev.showSources.vehiclelPerKm': '车辆每公里油耗（升/公里）',
  'ev.showSources.vehicleMPG': '车辆每加仑行驶里程（MPG）',
  'ev.showSources.yearsOfOwnership': '拥有年限',
  'ev.used.electricRange': '平均电续航里程',
  'ev.used.yearRange': '年份范围',
  'ev.usedCarTitle': '已使用{car}',
  'ev.yearsOwnership': '拥有/租赁年限',
  'evCard.electricRange': '电炉',
  'evCard.matchScore': '比赛比分',
  'evCard.seeDetails': '查看详情',
  'evCard.seeElectricVehicle': '参见电动汽车',
  'evCard.totalRange': '总射程',
  'eventCard.hostedBy': '由……主办',
  'eventCard.inPerson': '线下活动',
  'eventCard.inPersonAndVirtual': '线下+线上活动',
  'eventCard.learnMore': '了解更多',
  'eventCard.virtualEvent': '虚拟活动',
  'eventCatalog.noEvents':
    '未找到符合您当前搜索条件的活动。请尝试更改搜索条件。',
  'eventCatalog.noMatch': '我们没有找到任何匹配项。',
  events: '活动',
  'events.allLocations': '所有地点',
  'events.autoshow': '车展',
  'events.both': '线下和线上',
  'events.conference': '会议',
  'events.distance': '距离',
  'events.educationEvent': '教育活动',
  'events.inPerson': '亲自',
  'events.inPersonOrVirtual': '现场或线上',
  'events.nationwide': '全国',
  'events.nationWide': '全国',
  'events.rideAndDrive': '骑行和驾驶',
  'events.subHeader':
    '在即将举行的活动中，您可以亲自体验电动汽车，亲眼看看、亲手触摸感受一下。',
  'events.training': '训练',
  'events.virtual': '虚拟的',
  'events.webinar': '网络研讨会',
  eventsDateRange: '日期范围',
  eventsFilters: '过滤器',
  'eventSort.dateLtH': '日期（最早的在前）',
  evfilter: '过滤器',
  'evfilter.carTitle': '电动汽车偏好',
  'evfilter.fuel': '燃料',
  'evfilter.fuelTooltip':
    '纯电动汽车仅使用电力。插电式混合动力汽车可以使用电力和汽油。',
  'evfilter.type': '类型',
  evFuelType: '全电动',
  'evs.budgetAfterIncentives': '扣除激励措施后的预算',
  'evs.buttonMatchScoreAndFilters': '比赛得分和筛选条件',
  'evs.chargercard.chargingtime.na': '不适用',
  'evs.chargerCatalog.noChargers': '未找到充电器',
  'evs.chargingAvailability': '充电可用性',
  'evs.disclaimer':
    '所示车辆信息可能与实际库存不符。我们不对任何特定车辆或汽车制造商进行背书或推荐。',
  'evs.graph.compare':
    '按续航里程或价格比较电动汽车。将鼠标悬停在电动汽车上可查看更多详细信息。',
  'evs.graph.disclaimer':
    '所示车辆可能与实际库存不符。{companyName} 不认可或推荐任何特定车辆或汽车制造商。',
  'evs.graph.mobile': '要查看射程与成本图表，请在电脑上查看此页面。',
  'evs.graph.rangeVsCost': '射程与成本',
  'evs.graph.tiles': '车辆板块',
  'evs.graph.title': '电动汽车',
  'evs.helpMeChoose': '帮我选择',
  'evs.highPower.legend': '高功率电站',
  'evs.homeChargingAvailability': '家庭充电可用性',
  'evs.homeChargingAvailabilityTooltip':
    '如果你能在家快速充电，那么电动汽车会给你带来更多便利。',
  'evs.incentivesScoreOptions': '激励资格筛选条件',
  'evs.levelOne': '一级',
  'evs.levelTwo': '二级',
  'evs.matchScoreAndFilters': '优化匹配分数和筛选条件',
  'evs.matchScoreOptions': '过滤器',
  'evs.minSeats': '最低座位数',
  'evs.noCharging': '无需充电',
  'evs.other.legend': '其他类型的车站',
  'evs.public.legend': '公共车站',
  'evs.roundTripCommute': '平均每日里程',
  'evs.seats': '座位',
  'evs.slideMilesDrivenDaily': '最小射程',
  'evs.thirdParty':
    '*本网站包含指向第三方外部网站的链接。SDGE不对任何第三方网站的内容或产品承担任何责任。请注意，此车辆可能在您所在地区无法购买。请联系您当地的经销商以确认库存情况。',
  'evs.welcomeSub': '根据您的需求定制搜索条件，找到符合您需求的电动汽车。',
  'evs.welcomeSubMobile':
    '根据您的需求定制搜索条件，找到符合您需求的电动汽车。',
  'evSort.alphabetical': '按字母顺序排列',
  'evSort.chargerPower': '充电器电源',
  'evSort.electricRange': '电炉',
  'evSort.matchScore': '比赛比分',
  'evSort.priceHtL': '价格：从高到低',
  'evSort.priceLtH': '价格：从低到高',
  'evSort.title': '排序方式',
  FAQ: '常问问题',
  feet: '脚',
  filing_status_tooltip: '用于确定是否符合优惠资格。',
  fuel_tooltip: '选择您感兴趣的所有车身类型。',
  Finished: '完成的',
  'footer.allRights': '版权所有。',
  'footer.chargingStations': '{chargingStations}',
  'footer.compareVehicles': '{compareVehicles}',
  'footer.copyright':
    '© 1998-2026 圣地亚哥天然气电力公司。本文使用的商标均为其各自所有者的财产。保留所有权利。',
  'footer.disclaimer':
    '{COMPANY_NAME}® 公司是 Sempra® 的子公司。SDG&E® 和 San Diego Gas & Electric 是 San Diego Gas & Electric Company 的注册商标。',
  'footer.electricVehicles': '{electricVehicles}',
  'footer.homeChargers': '{homeChargers}',
  'footer.incentives': '{incentives}',
  'footer.jdpDisclaimer':
    '本页所示数据为基于第三方提供的数据估算得出。本资料仅供参考，不应作为税务、法律或财务建议的依据。J.D. Power® 和 SDGE 均不提供税务、法律或财务建议。在进行任何交易前，您应自行核实此处提供的估算数据。',
  'footer.poweredBy': '由 Zappyride 提供技术支持',
  'footer.ratepayerDisclaimer': '除非另有说明，本网站上的信息均由纳税人资助。',
  'footer.zappyDisclaimer':
    '本页所示数据为基于第三方提供的数据估算得出。本资料仅供参考，不应作为税务、法律或财务建议的依据。J.D. Power® 和 SDGE 均不提供税务、法律或财务建议。在进行任何交易前，您应自行核实此处提供的估算数据。',
  'footer.zappyDisclaimer.one':
    '电动汽车解决方案 © 2026 J.D. Power，经许可提供。',
  footerPhrase1: '费率和法规',
  footerPhrase10: '总电费',
  footerPhrase11: '顾客选择',
  footerPhrase2: '能源数据请求',
  footerPhrase3: '条款及细则',
  footerPhrase4: '联邦能源监管委员会行为准则——第717号命令',
  footerPhrase5: '重大项目',
  footerPhrase6: '客户服务',
  footerPhrase7: 'CPUC公告',
  footerPhrase8: '职业生涯',
  footerPhrase9: '隐私中心',
  forInstallation: '用于安装',
  forLevelTwoCharger: '适用于二级充电器',
  forSeparateMeter: '单独计量',
  free: '自由的',
  ft: '英尺',
  galperyear: '加仑/年',
  garage: '车库',
  gasoline: '汽油',
  gasolinePrice: '汽油价格',
  gasolinePriceInCentsPerGal_tooltip:
    '请输入您所在地区的汽油价格。我们的默认价格基于您所在地区最新的汽油价格，每月更新一次。',
  'graph.assumptions': '假设',
  'graph.cheaper': '更便宜',
  'graph.costDifferent': '为什么价格会不一样？',
  'graph.costOfOwnership.chart.electricity': '电',
  'graph.costOfOwnership.chart.gasoline': '汽油',
  'graph.costOfOwnership.chart.insurance': '保险',
  'graph.costOfOwnership.chart.maintenance': '维护',
  'graph.costOfOwnership.chart.vehicle': '车辆净收益、转售',
  'graph.costOfOwnership.description': '描述',
  'graph.costOfOwnership.descriptionRow.electricity': '电',
  'graph.costOfOwnership.descriptionRow.gasoline': '汽油',
  'graph.costOfOwnership.descriptionRow.insurance': '保险',
  'graph.costOfOwnership.descriptionRow.maintenance': '维护',
  'graph.costOfOwnership.descriptionRow.vehicle': '车辆',
  'graph.costOfOwnership.subTitle':
    '{carName} 是 {style} {costDeltaText} {costDeltaTextEnding}',
  'graph.costOfOwnership.subTitleThreeCars':
    '{carName} 是拥有成本最低的车型，使用寿命为 {yearsOfOwnership} 年。',
  'graph.costOfOwnership.title': '拥有成本',
  'graph.costOfOwnership.totalRow': '全部的',
  'graph.costToBreakdown': '故障成本',
  'graph.costToBreakdown.note': '注：盈亏平衡图假设车辆以现金购买。',
  'graph.costToBreakdown.subTitle': '比较 {car1} 和 {car2} 的累计生命周期成本',
  'graph.costToBreakdown.subTitleThreeCars':
    '比较 {car1}、{car2} 和 {car3} 的累计生命周期成本',
  'graph.costVsRange.afterIncentives': '从{price}开始（扣除激励措施后）',
  'graph.costVsRange.electricKilometerRange': '纯电续航里程：{kilometers} 公里',
  'graph.costVsRange.electricRange': '纯电续航里程：{miles} 英里',
  'graph.electricRange.assumption': '范围基于美国环保署的估算',
  'graph.electricRange.assumptions': '假设',
  'graph.electricRange.description': '描述',
  'graph.electricRange.electricity': '电',
  'graph.electricRange.gasoline': '汽油',
  'graph.electricRange.gasolineRange': '汽油系列',
  'graph.electricRange.subTitle': '{car} 的纯电续航里程为 {costDeltaText} 乘 {number} 英里。',
  'graph.electricRange.subTitleThreeCars': '{car} 拥有最长的电续航里程',
  'graph.electricRange.total': '全部的',
  'graph.fuelRange.chart.chargedHome': '在家充电',
  'graph.fuelRange.chart.description': '描述',
  'graph.fuelRange.chart.fuelBudget': '燃料预算',
  'graph.fuelRange.chart.howFar':
    '在 {budget} 的燃油预算下，{car} 能行驶多远？',
  'graph.fuelRange.chart.kilometers': '公里',
  'graph.fuelRange.chart.miles': '英里',
  'graph.fuelRange.chart.network': '在 Plug-In EVerywhere 网络上',
  'graph.fuelRange.chart.rangeOn': '射程',
  'graph.fuelRange.chart.similarGas': '类似的燃气汽车',
  'graph.fuelRange.chart.unlimited': '无限',
  'graph.graphValues': '图表值',
  'graph.hide': '隐藏 ',
  'graph.monthlyCostToFill.subTitle':
    '{carName} 是 {style} {costDeltaText}，每月填充',
  'graph.monthlyCostToFill.subTitleThreeCars':
    '{carName} 是每月加油最便宜的车型。',
  'graph.monthlyCostToFill.title': '每月加油费用',
  'graph.moreExpensive': '更贵',
  'graph.show': '展示 ',
  'graph.showCostBreakdown': '显示成本明细',
  'graph.similarGasVehicle': '类似燃气车辆',
  'graph.speedOfCharge.fastChargerTitle': '快速充电30分钟的充电量',
  'graph.speedOfCharge.fastChargingSpeed': '快速充电速度',
  'graph.speedOfCharge.kilometersLevelTwoChargerThreeCars':
    '使用二级充电器，每小时充电里程数最高。',
  'graph.speedOfCharge.kilometersThirtyFastChargeThreeCars':
    '快速充电30分钟可增加最多公里数',
  'graph.speedOfCharge.kmLevelTwoCharger': '使用二级充电器，每小时行驶公里数',
  'graph.speedOfCharge.kmThirtyFastCharge': '快速充电30分钟可行驶公里数',
  'graph.speedOfCharge.levelTwoChargingSpeed': '二级充电器速度',
  'graph.speedOfCharge.mphLevelTwoCharger':
    '使用二级充电器时，每小时行驶多少英里',
  'graph.speedOfCharge.mphLevelTwoChargerThreeCars':
    '使用二级充电器每小时充电里程数最高。',
  'graph.speedOfCharge.mphLevelTwoChargerTitle': '二级充电每小时收费金额',
  'graph.speedOfCharge.subTitle':
    '{car} 向 {number} {costDeltaText} {subTitleText} 充电',
  'graph.speedOfCharge.subTitleThreeCars': '{car} {subTitleText}',
  'graph.speedOfCharge.thirtyFastCharge': '快速充电30分钟可行驶里程',
  'graph.speedOfCharge.thirtyFastChargeThreeCars':
    '快速充电30分钟可增加最多里程',
  'graph.title.costAnalysis': '成本分析',
  'graph.title.electricRange': '电炉',
  'graph.title.miles': '迈尔斯',
  'graph.title.speedOfCharge': '充电速度',
  'graph.title.totalRange': '总射程',
  'graph.toOwnOver': '拥有超过',
  'graph.year': ' 年',
  'graph.years': ' 年',
  'graph.yourEV': '您的电动汽车选择',
  hcaCarCondition: '车辆状况',
  hcaCarMake: '汽车品牌',
  hcaCarModel: '汽车模型',
  hcaChargerLocation: '充电桩位置',
  hcaCurrentElectricRate: '当前电价',
  hcaCurrentMonthlyBill: '当前月账单',
  hcaDistanceSliderLabel: '距离：面板到充电位置',
  hcaDistanceSliderLabelToolTip:
    '请注意，由于墙壁、地板或室外空间等障碍物，电路通常不会在面板和充电位置之间呈直线铺设。',
  hcaElectricPanelLocation: '配电盘位置',
  hcaIncludedEnergyCosts: '包含能源成本',
  hcaNewestModels: '最新款',
  hcaOlderModels: '老款机型',
  hcaPanelLocationRoomType: '小组讨论位置 房间类型',
  hcaPortionPublicCharging: '公共充电部分',
  hcaPortionPublicChargingTooltip: '电动汽车车主几乎所有的充电都是在家进行的。',
  hcaPublicChargingCost: '公共充电费用',
  hcaWhenWillYouCharge: '你们什么时候收费？',
  'header.cards.electricians': '寻找持证电工',
  'header.cards.home-chargers': '商店首页充电器',
  'header.cards.incentives': '搜索激励',
  'header.cards.rates': '查看储蓄计算器',
  'header.chargingStations': '充电站',
  'header.compareVehicles': '车辆对比',
  'header.electricians': '电工',
  'header.electricVehicles': '电动汽车',
  'header.electricVehicles.v2': '探索电动汽车',
  'header.home': '家',
  'header.homeChargers': '家用充电器',
  'header.incentives': '激励措施',
  'header.newVehicles': '探索电动汽车选项',
  'header.promise.cta': '从激励措施开始',
  'header.promise.subtitle': '估算并比较电动汽车的成本、节省的费用、奖励等。',
  'header.promise.title': '充分发挥电动汽车的性能。',
  'header.rates': '储蓄计算器',
  'header.usedVehicles': '探索电动汽车选项',
  here: '这里',
  high: '高的',
  home: '家',
  'home.vehicleCarousel.browseAllEvs': '浏览所有电动汽车',
  'home.vehicleCarousel.compareEvs': '比较电动汽车',
  'home.vehicleCarouselSubTitle':
    '将你的选择与同类型的燃油车进行比较。电动汽车可以帮你省钱，\n\n因为它的拥有和维护成本可能比纯燃油车更低。\n\n',
  'home.vehicleCarouselTitle':
    '电动汽车的数量比以往任何时候都多。快来找到属于你的那一款吧！',
  homechargerChargerType: '充电器类型',
  homechargerEvfilter: '基本筛选器',
  homeChargers: '家用充电器',
  'homeChargers.cable': '{length} 英尺电缆',
  'homechargers.caption': '本网站列出的家用充电器并非由 SDG&E 生产或认可。',
  'homeChargers.cordLength': '线缆长度',
  'homeChargers.cordLengthHtL': '线缆长度：从高到低',
  'homeChargers.cordLengthLtH': '线缆长度：从低到高',
  'homeChargers.disclaimer':
    '充电器制造商，想让您的充电器出现在这里吗？请联系{email}。',
  'homeChargers.hardwired': '硬连接',
  'homeChargers.meterCable': '{length} 米电缆',
  'homeChargers.portable': '便携的',
  'homeChargers.price': '价格',
  'homeChargers.selectMake': '选择品牌',
  'homeChargers.selectModel': '选择型号',
  'homeChargers.socket': '插座',
  'homeChargers.socketTooltip':
    '家用电动汽车充电器的插头样式各不相同。这些插头样式与充电器插脚插入墙壁插座的方式相对应。如果您不确定哪种插座最适合您的房屋或车库，请咨询持证电工。',
  'homeChargers.subText': '选择您感兴趣的车辆，即可查看充满电的具体充电时间。',
  'homeChargers.subtitle':
    '查找符合您家庭需求和电动汽车偏好的二级电动汽车充电桩。调整筛选条件以获得个性化搜索结果。',
  'homeChargers.title': '家用充电器',
  'homeChargers.toFullCharge': '充满电',
  'homeChargers.wallMounted': '安装',
  'homeChargers.wifi': 'WiFi 连接',
  'homeChargersCard.beforeIncentives': '激励措施之前',
  'homeChargersCard.buy': '查看详情',
  'homeChargersCard.socket': '{socket} 插座',
  'homeChargersCard.teslaWarning': '这款充电器仅适用于特斯拉车型。',
  'homepage.incentives.exporeIncentives': '探索奖励',
  'homepage.incentives.subTitle':
    '无论您是购买还是租赁电动汽车，看看您能省多少钱。{lineBreak} 优惠政策根据您的居住地而定。',
  'homepage.incentives.title': '探索电动汽车激励措施和税收抵免政策',
  'homepage.linkCard.browseElectricVehicles': '浏览电动汽车',
  'homepage.linkCard.discoverIncentives': '探索 {lineBreak} 奖励',
  'homepage.linkCard.findDealers': '查找 {lineBreak} 经销商',
  'homepage.linkCard.homeChargers': '首页 {lineBreak} 充电器',
  'homepage.linkCard.locateChargingStations': '查找充电站 {lineBreak}',
  'homepage.vehicleCarousel.findEVButton': '查看所有车辆',
  'homepage.vehicleCarousel.subTitle':
    '选择一辆电动汽车，并将其成本与类似的燃油车进行比较。电动汽车可以帮助您省钱，因为它们的拥有和维护成本通常比纯汽油动力竞争对手更低。',
  'homepage.vehicleCarousel.title':
    '现有{vehicleCount}款电动汽车可供选择。快来发现属于你的那一款吧！',
  'homepage.welcome': '科尔顿重获新生',
  'homepage.welcomeSub':
    '科尔顿电力公司为您提供电动汽车指南。估算并比较成本、节省金额、电动汽车补贴等信息。',
  'homepage.zipcode.disclaimer':
    '个性化定价方案，只需不到1分钟即可获得。无需注册。',
  'homepage.zipcode.getStarted': '开始使用',
  'homepage.zipcode.subtitle': '该工具将明确指出成本最低的电动汽车定价方案。',
  'homepage.zipcode.title':
    '您知道我们提供多种电动汽车定价方案吗？找到最适合您的电动汽车定价方案。',
  homeWiring: '家庭布线',
  incentives: '激励措施',
  'incentives.clunkerNone':
    '某些奖励措施会补偿您报废现有车辆（也称为老旧车辆）。',
  'incentives.clunkertoolTip':
    '某些激励措施会对您报废现有车辆（也称为老旧车辆）进行补偿。具体来说，',
  'incentives.clunkertoolTipContd':
    '您所在地区均可享受这些优惠。不同优惠的申请资格要求各不相同；请查看项目详情。',
  household_income_tooltip: '合并所有家庭成员的收入。用于确定是否符合优惠资格。',
  household_size_tooltip:
    '用于确定是否符合优惠资格。请包括您家庭中的所有成员（配偶、受抚养人等）。很少有优惠涉及超过8人的家庭，因此如果您的家庭人数为8人或以上，请选择8。',
  'incentives.electricityProvider': '电力供应商',
  'incentives.headOfHousehold': '户主',
  'incentives.householdIncome': '家庭收入',
  'incentives.householdIncomeTooltip':
    '用于确定您是否符合奖励资格。请填写您家庭的所有成员（配偶、受抚养人等）。很少有奖励政策提及超过 8 人的家庭，因此如果您的家庭人数为 8 人或以上，请选择 8。',
  'incentives.householdSize': '家庭规模',
  'incentives.householdSizeTooltip':
    '请将您家庭的所有成员（配偶、子女等）都包括在内。用于确定您是否有资格获得奖励。',
  'incentives.incentiveEligibility': '更新奖励资格',
  'incentives.income': '收入和税务状况',
  'incentives.incomeTooltip':
    '奖励资格和奖励金额通常取决于您的收入。低收入客户通常可获得更高的返利。',
  'incentives.less': ' 较少的',
  'incentives.location': '地点',
  'incentives.locationTooltip':
    '许多优惠政策取决于您的居住地。请输入您的邮政编码，以便我们确定您所在地区可享受哪些优惠政策。',
  'incentives.married': '已婚',
  'incentives.more': '... 更多的',
  'incentives.planClunker': '你打算把旧车报废吗？',
  'incentives.retiringVehicleTooltip': '某些优惠政策可能要求报废旧燃油车。',
  'incentives.selectModel': '选择模型',
  'incentives.selectTrim': '选择修剪',
  'incentives.single': '单身的',
  'incentives.subTitle':
    '您可能有资格获得优惠，从而降低购买或租赁电动汽车的成本。调整筛选条件以获得个性化结果，点击每个图块了解更多信息。',
  'incentives.taxFilingStatus': '税务申报状态',
  'incentives.taxFilingStatusTooltip': '用于确定奖励资格。',
  'incentives.title': '电动汽车激励措施',
  'incentives.tradeIn': '车辆报废？',
  'incentives.vehicleType': '车辆类型',
  'incentives.vehicleTypeTooltip': '根据您购买的车型不同，可享受不同的优惠。',
  'incentives.whichVehicle': '您计划购买哪款车？',
  'incentiveSort.aToZ': '按字母顺序：A 到 Z',
  'incentiveSort.largest': '最大第一',
  'incentiveSort.zToA': '按字母顺序：Z 到 A',
  'input-zipcode-for-rate-comp-launch':
    '用于确定您是否符合奖励资格。请填写您家庭的所有成员（配偶、受抚养人等）。很少有奖励政策提及超过 8 人的家庭，因此如果您的家庭人数为 8 人或以上，请选择 8。',
  install: '安装',
  kgperyear: '公斤/年',
  kilometersShort: '公里',
  lbsperyear: '磅/年',
  linkUnavailable: '网络连接不可用',
  literperyear: '升/年',
  liveInResidenceState:
    '居住在由 Xcel Energy 提供电力服务的住宅中（位于 {stateName}）。',
  loading: '加载中',
  low: '低的',
  m: '米',
  make: '制作',
  maps: '地图',
  'matchScore.adjustment': '调整',
  'matchScore.budget': '预算',
  'matchScore.charging': '收费',
  'matchScore.maxScore': '最高分',
  'matchScore.popover': '您的匹配评分是根据您选择的偏好计算得出的。',
  'matchScore.range': '范围',
  'matchScore.seats': '座位',
  'matchScore.title': '比赛比分',
  'matchScore.totalScore': '总分',
  'matchScore.yourScore': '你的得分',
  medium: '中等的',
  'miles-driven-annually-range_tooltip':
    '根据交通部对2020年年均行驶里程的估算，普通司机每年行驶约16,000英里。',
  milesDrivenAnnually_tooltip: '根据交通部的数据',
  milesWord: '迈尔斯',
  modal1: '您每月电费账单的平均金额是多少？',
  modal10: '提示：普通驾驶员每年行驶约 12,000 英里。',
  modal11: '哪种充电时间最适合您？',
  modal12:
    '提示：夜间（凌晨 12 点至 6 点）充电最经济实惠。您可以设置电动汽车在最适合您的时间段内充电。',
  modal13: '全天候',
  modal14: '你们目前的定价方案是什么？',
  modal15: '提示：大多数客户都在使用 TOU-DR1。',
  modal16:
    '注：对于采用非电动汽车定价方案（包括 DR、TOU-DR1 和 DR-SES）的客户，我们假设您目前驾驶的燃油车类型、品牌和价格与您在第二步中选择的电动汽车相似，并显示您改用此电动汽车后可节省的费用。对于采用 EV-TOU-5 定价方案的客户，我们假设您已拥有所选电动汽车，并显示您目前相对于非电动汽车定价方案的节省费用。',
  modal2: '步',
  modal3: '的',
  modal4: '下一个',
  modal5: '您目前拥有或想要购买/租赁哪款电动汽车？',
  modal6: '提示：您可以在查看结果后调整这些筛选条件。',
  modal7:
    '选择您目前或心仪的电动汽车，即可查看不同定价方案下的潜在节省金额。由于不同车型在电力性能和效率方面存在差异，因此车辆选择会影响潜在的电费节省金额。',
  modal8: '以前的',
  modal9: '您平均每年行驶多少英里？',
  model: '模型',
  'model.year': '车型年份',
  month: '月',
  monthWord: '月',
  new: '新的',
  newVehicles: '新车',
  no: '不',
  overTenYears: '超过10年',
  pages: '页',
  personalizeIncentives: '个性化激励措施',
  phevFuelType: '插电式混合动力',
  portionOfPublicCharging: '公共充电部分',
  portionOfPublicChargingTooltip:
    '如果无法在家充电，则需要使用付费公共充电站。请估算电动汽车充电时间中，有多少百分比的时间会在付费公共充电站充电，而不是在家充电。',
  'pre-owned': '二手',
  Preferredpartner: '优选合作伙伴',
  prefferedEvChargingTimeframe: '理想的电动汽车充电时间范围',
  prefferedEvChargingTimeframe_tooltip:
    '夜间（凌晨 12 点至 6 点）充电最具成本效益。您可以设置电动汽车在最适合您的时间段内充电。',
  prefferedEvMake: '首选电动汽车品牌',
  prefferedEvMake_tooltip:
    '注：我们假设您目前驾驶的燃油车类型、品牌和价格与所选电动汽车相似。',
  prefferedEvModel: '首选电动汽车车型',
  'pricePanels.cash': '现金',
  'pricePanels.downPayment': '首付',
  'pricePanels.downPaymentDescription': '建议零售价的 10% 加税',
  'pricePanels.firstLeasePayment': '首期租金',
  'pricePanels.incentivesForLease': '租赁优惠',
  'pricePanels.lease': '租',
  'pricePanels.leasePayment': '租赁付款',
  'pricePanels.loan': '贷款',
  'pricePanels.loanPayment': '贷款支付',
  'pricePanels.perMonth': ' / 月',
  'pricePanels.seeAllCosts': '查看所有费用',
  'pricePanels.seeAllIncentives': '查看所有优惠',
  'rateAdvisor.caption':
    '此节能计算器工具仅供参考。它并不承诺或保证您的实际充电费用与工具中显示的费用完全一致。SDG&E 不保证估算费用信息的准确性、完整性或实用性。SDG&E 明确声明，对于因使用此节能计算器工具而引起的任何性质的损失，概不承担任何责任。您的实际充电费用将受多种因素影响。“SDG&E”指圣地亚哥天然气电力公司。©2022 SDG&E。版权所有。',
  'rateAdvisor.pricingPlanComparison': '价格方案比较',
  'rateAdvisor.sub':
    '购买电动汽车可帮您节省开支。调整筛选条件即可查看您的节省金额。',
  'rateAdvisor.title': '储蓄计算器',
  'rateComparison.youAreAlreadySaving':
    '如果您拥有一辆电动汽车并使用 {highlight} 费率计划，您已经节省了高达 {highlightText}。',
  'rateComparison.youAreAlreadySavingVehicle':
    '使用 {selectedVehicle}，您每年在 {highlight} 上最多可节省 {highlightText}。',
  'rateComparison.youAreSaving':
    '如果您拥有一辆电动汽车并使用 {highlight} 费率计划，您最多可以节省 {highlightText}。',
  'rateComparison.youAreSavingVehicle':
    '使用 {selectedVehicle}，每年可在 {highlight} 上节省 {highlightText}。',
  rateDRSESParagraph1:
    'DR-SES 是专为太阳能和其他可再生能源用户设计的方案。\n\n价格根据时间和星期几以及您的用电量而定。\n\n您',
  rateDRSESParagraph2:
    '如果您生产可再生能源，\n\n并且您可以将用电活动转移到下午 4 点之前和晚上 9 点之后，\n\n并且您可以利用非高峰时段较低的电价，\n\n那么这个方案可能很适合您。',
  rateEVTOU5Paragraph1:
    'EV-TOU-5 计划旨在为客户在家充电电动汽车。\n\n价格根据您的用电量和用电量而定，分为三个\n\n计费时段。您只需支付基本服务费，即可享受我们\n\n最低的夜间电动汽车家庭充电价格。',
  rateEVTOU5Paragraph2:
    '如果您能将部分用电时间转移到下午 4 点至晚上 9 点的用电高峰时段之外，并且能够定期在深夜的超低谷时段为电动汽车充电，那么这个方案可能很适合您。',
  rateTOUDR1Paragraph1:
    'TOU-DR1 定价模式基于您的用电量，以及\n\n您用电的时间和日期。该模式分为三个计费时段，\n\n让您有机会在晚上和周末节省更多电费。',
  rateTOUDR1Paragraph2:
    '如果您能将部分用电时间转移到其他时段，例如下午 4 点至晚上 9 点的用电高峰期之外，并且能够利用夜间和周末的非高峰时段较低的电价，那么这个方案可能很适合您。\n\n',
  regularResidential: '普通住宅',
  'results.updated': '结果已更新至：',
  saved: '已保存',
  'select-charger-level_tooltip': '如果您可以在家快速充电，将有更多电动汽车适合您。',
  savingsGraphDisclaimer:
    '* 假设您使用此定价方案为您的家庭供电，并且您目前驾驶的燃油汽车的类型、品牌和价格与您选择的电动汽车相似。',
  savingsGraphEVLabel: '电动汽车',
  savingsGraphGasLabel: '汽油',
  savingsGraphHomeLabel: '家',
  savingsGraphYAxis: '预计每年平均成本',
  source: '来源',
  sources: '来源',
  'tabbed-maps-all-stations-tab': '充电站',
  'tabbed-maps-dealer-catalog-tab': '经销商',
  'tabbed-maps-electricians-tab': '电工',
  'tabbed-maps-route-tab': '绘制路线',
  total: '全部的',
  trade_in_tooltip: '某些优惠可能要求淘汰旧的燃油车。',
  trim: '修剪',
  type_tooltip: '纯电动汽车仅使用电力。插电式混合动力车既可以使用电力，也可以使用汽油。',
  Unfinished: '未完成',
  updateZipcode: '更新邮政编码',
  usedElectricVehicles: '二手电动汽车',
  'vehicle.afterIncentives': '奖励后',
  'vehicle.age.four': '4岁以上',
  'vehicle.age.one': '0-1岁',
  'vehicle.age.two': '2-3岁',
  'vehicle.allElectric': '全电动',
  'vehicle.batterySize': '电池尺寸',
  'vehicle.bev': '电',
  'vehicle.coTwoEmissions': '减少二氧化碳排放',
  'vehicle.electricRange': '电炉',
  'vehicle.estimatedIncentives': '预计激励措施',
  'vehicle.fewer': '更少',
  'vehicle.fuelType': '燃料类型',
  'vehicle.gas': '汽油',
  'vehicle.gasoline.metricPrice': '汽油价格（美元/升）',
  'vehicle.gasoline.price': '汽油价格（美元/加仑）',
  'vehicle.greater': '更大的',
  'vehicle.kilometers': '公里',
  'vehicle.kilometersCapital': '公里',
  'vehicle.kilometersPerThirtyFastCharge': '快速充电30分钟可行驶公里数',
  'vehicle.kilometersShort': '公里',
  'vehicle.miles': '英里',
  'vehicle.milesCapital': '迈尔斯',
  'vehicle.milesCaptital': '迈尔斯',
  'vehicle.milesPerThirtyFastCharge': '快速充电30分钟后行驶里程',
  'vehicle.milesShort': '米',
  'vehicle.more': '更多的',
  'vehicle.msrp': '建议零售价',
  'vehicle.phev': '电力和汽油',
  'vehicle.plugInHybrid': '插电式混合动力',
  'vehicle.status': '车辆状态',
  'vehicle.timeToChargeLvlTwo': '充电时间 - 等级 2',
  'vehicle.trees': '树木',
  'vehicle.type': '类型',
  'vehicle.type.coupe': '双门轿跑车',
  'vehicle.type.crossover': '跨界车',
  'vehicle.type.hatchback': '掀背车',
  'vehicle.type.minivan': '小型货车',
  'vehicle.type.sedan': '轿车',
  'vehicle.type.suv': 'SUV',
  'vehicle.type.truck': '卡车',
  'vehicle.type.wagon': '车皮',
  'vehicle.view': '看法',
  vehicles: '车辆',
  'vehicles.new': '新的',
  'vehicles.none': '未找到车辆',
  'incentives.noneFound':
    '没有符合您当前筛选条件的激励措施。请尝试放宽车辆或资格筛选条件。',
  'vehicles.used': '用过的',
  vehicleType: '请选择您感兴趣的所有车身类型。',
  viewSavings: '查看节省金额',
  Website: '网站',
  yes: '是的',
  youAreEligible: '你',
  zipcode: '邮政编码',
  zipCode: '邮政编码',
};

export default ZHHANS_CUSTOM;
